import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import Card from "./Card";
import axios from "axios";
import { useEffect, useState } from "react";

const loaders = [
  1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
];

// import React from "react";
// list genres `https://api.themoviedb.org/3/genre/movie/list?api_key=${key}&language=en-US`
const key = "b55d580200c51623fe9608f8f064a09b";

const CarouselMovies = ({ genreId }) => {
  const [moviesByGenre, setMoviesByGenre] = useState("");

  const getMoviesByGenre = async () => {
    const response = await axios.get(
      `
      https://api.themoviedb.org/3/discover/movie?api_key=${key}&with_genres=${genreId}&language=en-US`
    );
    setMoviesByGenre(response.data.results);
  };

  useEffect(() => {
    getMoviesByGenre();
  }, []);

  useEffect(() => {
    getMoviesByGenre();
  }, [genreId]);
  console.log(genreId);

  return (
    <Carousel
      className="carousel"
      additionalTransfrom={0}
      arrows
      autoPlay={false}
      autoPlaySpeed={7000}
      containerClass=""
      dotListClass=""
      draggable
      focusOnSelect={false}
      infinite
      itemClass="margin-1px"
      keyBoardControl
      minimumTouchDrag={80}
      renderButtonGroupOutside={false}
      renderDotsOutside={false}
      responsive={{
        desktopxl: {
          breakpoint: {
            max: 3000,
            min: 2000,
          },
          items: 9,
          partialVisibilityGutter: 40,
        },
        desktop: {
          breakpoint: {
            max: 1999,
            min: 1200,
          },
          items: 7,
          partialVisibilityGutter: 40,
        },
        tabletxl: {
          breakpoint: {
            max: 1200,
            min: 1099,
          },
          items: 5,
          partialVisibilityGutter: 30,
        },
        tablet: {
          breakpoint: {
            max: 1100,
            min: 464,
          },
          items: 3,
          partialVisibilityGutter: 30,
        },
        mobile: {
          breakpoint: {
            max: 463,
            min: 0,
          },
          items: 1,
          partialVisibilityGutter: 30,
        },
      }}
      showDots={false}
      sliderClass=""
      // slidesToSlide={1}
      swipeable
      centerMode
    >
      {moviesByGenre === ""
        ? loaders.map((loader, index) => {
            return <Card type="loader" key={index} />;
          })
        : moviesByGenre.map((movie) => {
            return <Card movie={movie} key={movie.id} />;
          })}
      {/* {moviesByGenre &&
        moviesByGenre.map((movie) => {
          return <Card movie={movie} key={movie.id} />;
        })} */}
    </Carousel>
  );
};

export default CarouselMovies;
